import { AxiosInstance } from "axios";
import { FriendRequest, User } from "./User.types";
import { toast } from "react-toastify";

export const findUserByKeycloakId = async (
  axios: AxiosInstance,
  keycloakId: string
): Promise<User | undefined> => {
  return axios
    .get("user/", { params: { keycloakId } })
    .then((res) => res.data)
    .catch((exc) => {
      console.error("Error while loading user", exc);
      return undefined;
    });
};

export const createNewUser = async (
  axios: AxiosInstance,
  user: User
): Promise<User | undefined> => {
  return axios
    .post("user/", user)
    .then((res) => res.data)
    .catch((exc) => {
      console.error("Error while creating User", exc);
      return undefined;
    });
};

export const searchUserByName = async (
  axios: AxiosInstance,
  searchValue: string
): Promise<User[]> => {
  return axios
    .get("/user/search", { params: { searchValue } })
    .then((res) => res.data)
    .catch((exc) => {
      console.error("Error while searching user", exc);
      toast("Hoppla, das hat nicht geklappt!");
      return [];
    });
};

export const createNewFriendRequest = async (
  axios: AxiosInstance,
  request: FriendRequest
): Promise<boolean> => {
  return axios
    .post("/friend/", request)
    .then((res) => res.status === 201)
    .catch((exc) => {
      console.error("Error while searching user", exc);
      toast("Hoppla, das hat nicht geklappt!");
      return false;
    });
};

export const getAllUsersById = async (
  axios: AxiosInstance,
  ids: string[]
): Promise<User[]> => {
  return axios
    .get("/user/all/id", { params: { ids: ids.join(",") } })
    .then((res) => res.data)
    .catch((exc) => {
      console.error("Error while loading users", exc);
      toast("Hoppla, das hat nicht geklappt");
      return [];
    });
};
